import { useTranslation } from 'react-i18next';
import { useRobotListWithMembers, useCanAccess } from '@mygpt/app';
import Access from '@/components/Access';
import ContainerHeader from '@/components/Headers/ContainerHeader';
import { Navigate } from 'react-router-dom';
import { useGPTStore } from '@/store';

const AccessPage = () => {
  const { t } = useTranslation();
  const { data: robotList } = useRobotListWithMembers();
  const canAccessCollaboration = useCanAccess('enable_collaboration');
  const { assetScope } = useGPTStore();
  const isCloudMode = import.meta.env.VITE_MODE !== 'local';

  // 组织模式下使用组织内成员选择器
  const shareSource = isCloudMode && assetScope !== null ? ('organization' as const) : undefined;

  if (!canAccessCollaboration) {
    return <Navigate to="/no-access" replace />;
  }

  return (
    <>
      <ContainerHeader title={t('page.access_title')} description={t('page.access_description')} />
      <div style={{ position: 'relative', height: `calc(100vh - 150px)` }}>
        <Access shareSource={shareSource} />
      </div>
    </>
  );
};

export default AccessPage;
